import React    from 'react'
import { Icon } from 'antd'
import './styles.scss'

export default ({ search_loading, on_close, on_search }) => (
  <div className='search'>
    {
      search_loading ? <Icon type="loading" className='search-icon'/>:
        <Icon type='search' className='search-icon'/>
    }
    <input className='search-input' placeholder='What are you looking for?'
           id = "txtSearch"
           onKeyDown = {e=>e.keyCode === 13 ? on_search(e.currentTarget.value):null}
           onChange={e=>on_search(e.target.value)}
           autoFocus/>
    <Icon type="close-circle-o" className='search-close' onClick={on_close} />
  </div>
)
